import { render, staticRenderFns } from "./ct-customer-config.vue?vue&type=template&id=efaebaec&scoped=true"
import script from "./ct-customer-config.vue?vue&type=script&lang=js"
export * from "./ct-customer-config.vue?vue&type=script&lang=js"
import style0 from "./ct-customer-config.vue?vue&type=style&index=0&id=efaebaec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaebaec",
  null
  
)

export default component.exports